import {createFileRoute} from "@tanstack/react-router";
import {catalogSearchValidator} from "../data-sources/-model";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/data-clusters")({
    validateSearch: catalogSearchValidator,
    loader: ({context}) => ({accessToken: context.authenticationStatus.accessToken, intellsysBaseUrl: context.intellsysBaseUrl}),
    component: RouteComponent,
});
